import type { UseFormReturn } from 'react-hook-form';
import type { ExtractStringArrayKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import { useRoleActions } from '../../../../resource/resources/artifacts/role/roleResource';
import { Form_PropertyFieldArrayReference } from '../reference-text-fields/Form_PropertyFieldArrayReference';

export const Form_RoleFieldArray = <T extends object>({
    name,
    form,
    readOnly,
    disabled,
    versionedIn,
    label,
}: {
    form: UseFormReturn<T>;
    readOnly: boolean;
    disabled?: boolean;
    versionedIn: string;
    name: ExtractStringArrayKeys<T, false>;
    label: string;
}) => {
    const roleActions = useRoleActions();
    const rolesQuery = roleActions.useGetAllResources(versionedIn);

    return (
        <Form_PropertyFieldArrayReference
            idSelector={'objectId'}
            control={form.control}
            name={name}
            query={rolesQuery}
            readOnly={readOnly}
            label={label}
            disabled={disabled}
            labelAccessor={(r) => r.name}
            propertyValidation={undefined}
            propertyDetails={undefined}
            uniqueSelection={true}
            initialOpen={true}
            withoutDuplicates={true}
            withSearch={true}
        />
    );
};
